import * as Yup from 'yup'

import type { ProductsSyncStatus } from './AppsTiktokShop.types'

export const configurationFormValidationSchema = Yup.object().shape({
  shopId: Yup.string().required(),
  warehouseId: Yup.string().required(),
})

export const settingsFormValidationSchema = Yup.object().shape({
  salesEnabled: Yup.boolean(),
  priceIncreaseEnabled: Yup.boolean(),
  priceIncrease: Yup.number().required().integer().min(0).max(100),
})

export const productSyncStatuses: ProductsSyncStatus[] = ['active', 'pending', 'denied']

export const DEFAULT_PRICE_PERCENTAGE_INCREASE = 5
